import { render, staticRenderFns } from "./EditAssetGroup.vue?vue&type=template&id=5a85e8bb&"
import script from "./EditAssetGroup.vue?vue&type=script&lang=js&"
export * from "./EditAssetGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports